"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
var applyChange_1 = require("./editInfoUtils/applyChange");
var canRegenerateImage_1 = require("./api/canRegenerateImage");
var DragAndDropHelper_1 = require("../../pluginUtils/DragAndDropHelper");
var getGeneratedImageSize_1 = require("./editInfoUtils/getGeneratedImageSize");
var Cropper_1 = require("./imageEditors/Cropper");
var editInfo_1 = require("./editInfoUtils/editInfo");
var Rotator_1 = require("./imageEditors/Rotator");
var roosterjs_editor_api_1 = require("roosterjs-editor-api");
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
var Resizer_1 = require("./imageEditors/Resizer");
var SHIFT_KEYCODE = 16;
var CTRL_KEYCODE = 17;
var ALT_KEYCODE = 18;
var DIRECTIONS = 8;
var DirectionRad = (Math.PI * 2) / DIRECTIONS;
var DirectionOrder = ['nw', 'n', 'ne', 'e', 'se', 's', 'sw', 'w'];
/**
 * Map the experimental features to image edit operations to help determine which operation is allowed
 */
var FeatureToOperationMap = (_a = {},
    _a["SingleDirectionResize" /* SingleDirectionResize */] = 2 /* SideResize */,
    _a["ImageRotate" /* ImageRotate */] = 4 /* Rotate */,
    _a["ImageCrop" /* ImageCrop */] = 8 /* Crop */,
    _a);
/**
 * Default image edit options
 */
var DefaultOptions = {
    borderColor: '#DB626C',
    minWidth: 10,
    minHeight: 10,
    preserveRatio: false,
    minRotateDeg: 5,
    imageSelector: 'img',
    rotateIconHTML: null,
};
/**
 * Map the image edit operation to a function that returns editing elements HTML to help
 * build image editing UI
 */
var ImageEditHTMLMap = (_b = {},
    _b[1 /* CornerResize */] = Resizer_1.getCornerResizeHTML,
    _b[2 /* SideResize */] = Resizer_1.getSideResizeHTML,
    _b[4 /* Rotate */] = Rotator_1.getRotateHTML,
    _b[8 /* Crop */] = Cropper_1.getCropHTML,
    _b);
/**
 * Image edit entity name
 */
var IMAGE_EDIT_WRAPPER_ENTITY_TYPE = 'IMAGE_EDIT_WRAPPER';
/**
 * Default background colors for rotate handle
 */
var LIGHT_MODE_BGCOLOR = 'white';
var DARK_MODE_BGCOLOR = '#333';
/**
 * ImageEdit plugin provides the ability to edit an inline image in editor, including image resizing, rotation and cropping
 */
var ImageEdit = /** @class */ (function () {
    /**
     * Create a new instance of ImageEdit
     * @param options Image editing options
     */
    function ImageEdit(options) {
        var _this = this;
        // Allowed editing operations
        this.allowedOperations = 1 /* CornerResize */;
        /**
         * quit editing mode when editor lose focus
         */
        this.onBlur = function () {
            _this.setEditingImage(null);
        };
        /**
         * Remove the temp wrapper of the image
         * @param wrapper The wrapper object to remove. If not specified, remove all existing wrappers.
         */
        this.removeWrapper = function (wrapper) {
            var parent = wrapper === null || wrapper === void 0 ? void 0 : wrapper.parentNode;
            var img = wrapper === null || wrapper === void 0 ? void 0 : wrapper.querySelector('img');
            if (img && parent) {
                img.style.position = '';
                img.style.margin = null;
                img.style.textAlign = null;
                parent.insertBefore(img, wrapper);
                parent.removeChild(wrapper);
            }
        };
        /**
         * Update image edit elements to reflect current editing result
         * @param context
         */
        this.updateWrapper = function (context) {
            var wrapper = _this.getImageWrapper(_this.image);
            if (wrapper) {
                // Prepare: get related editing elements
                var cropContainers = getEditElements(wrapper, "r_cropC" /* CropContainer */);
                var cropOverlays = getEditElements(wrapper, "r_cropO" /* CropOverlay */);
                var rotateCenter = getEditElements(wrapper, "r_rotateC" /* RotateCenter */)[0];
                var rotateHandle = getEditElements(wrapper, "r_rotateH" /* RotateHandle */)[0];
                var resizeHandles = getEditElements(wrapper, "r_resizeH" /* ResizeHandle */);
                var cropHandles = getEditElements(wrapper, "r_cropH" /* CropHandle */);
                // Cropping and resizing will show different UI, so check if it is cropping here first
                var isCropping = cropContainers.length == 1 && cropOverlays.length == 4;
                var _a = _this.editInfo, angleRad = _a.angleRad, bottomPercent = _a.bottomPercent, leftPercent = _a.leftPercent, rightPercent = _a.rightPercent, topPercent = _a.topPercent;
                // Width/height of the image
                var _b = getGeneratedImageSize_1.default(_this.editInfo, isCropping), targetWidth = _b.targetWidth, targetHeight = _b.targetHeight, originalWidth = _b.originalWidth, originalHeight = _b.originalHeight, visibleWidth = _b.visibleWidth, visibleHeight = _b.visibleHeight;
                var marginHorizontal = (targetWidth - visibleWidth) / 2;
                var marginVertical = (targetHeight - visibleHeight) / 2;
                var cropLeftPx = originalWidth * leftPercent;
                var cropRightPx = originalWidth * rightPercent;
                var cropTopPx = originalHeight * topPercent;
                var cropBottomPx = originalHeight * bottomPercent;
                // Update size and margin of the wrapper
                wrapper.style.width = getPx(visibleWidth);
                wrapper.style.height = getPx(visibleHeight);
                wrapper.style.margin = marginVertical + "px " + marginHorizontal + "px";
                wrapper.style.transform = "rotate(" + angleRad + "rad)";
                // Update the text-alignment to avoid the image to overflow if the parent element have align center or right
                // or if the direction is Right To Left
                wrapper.style.textAlign = isRtl(wrapper.parentNode) ? 'right' : 'left';
                // Update size of the image
                _this.image.style.width = getPx(originalWidth);
                _this.image.style.height = getPx(originalHeight);
                if (isCropping) {
                    // For crop, we also need to set position of the overlays
                    setSize(cropContainers[0], cropLeftPx, cropTopPx, cropRightPx, cropBottomPx, undefined, undefined);
                    setSize(cropOverlays[0], 0, 0, cropRightPx, undefined, undefined, cropTopPx);
                    setSize(cropOverlays[1], undefined, 0, 0, cropBottomPx, cropRightPx, undefined);
                    setSize(cropOverlays[2], cropLeftPx, undefined, 0, 0, undefined, cropBottomPx);
                    setSize(cropOverlays[3], 0, cropTopPx, undefined, 0, cropLeftPx, undefined);
                    updateHandleCursor(cropHandles, angleRad);
                }
                else {
                    // For rotate/resize, set the margin of the image so that cropped part won't be visible
                    _this.image.style.margin = -cropTopPx + "px 0 0 " + -cropLeftPx + "px";
                    // Double check resize
                    if ((context === null || context === void 0 ? void 0 : context.elementClass) == "r_resizeH" /* ResizeHandle */) {
                        var clientWidth = wrapper.clientWidth;
                        var clientHeight = wrapper.clientHeight;
                        _this.wasResized = true;
                        Resizer_1.doubleCheckResize(_this.editInfo, _this.options.preserveRatio, clientWidth, clientHeight);
                        _this.updateWrapper();
                    }
                    Rotator_1.updateRotateHandlePosition(_this.editInfo, _this.editor.getRelativeDistanceToEditor(wrapper, true /*addScroll*/), marginVertical, rotateCenter, rotateHandle);
                    updateHandleCursor(resizeHandles, angleRad);
                }
            }
        };
        this.options = __assign(__assign({}, DefaultOptions), (options || {}));
    }
    /**
     * Get a friendly name of this plugin
     */
    ImageEdit.prototype.getName = function () {
        return 'ImageEdit';
    };
    /**
     * Initialize this plugin. This should only be called from Editor
     * @param editor Editor instance
     */
    ImageEdit.prototype.initialize = function (editor) {
        var _this = this;
        this.editor = editor;
        this.disposer = editor.addDomEventHandler('blur', this.onBlur);
        // Read current enabled features from editor to determine which editing operations are allowed
        Object.keys(FeatureToOperationMap).forEach(function (key) {
            _this.allowedOperations |= _this.editor.isFeatureEnabled(key)
                ? FeatureToOperationMap[key]
                : 0;
        });
    };
    /**
     * Dispose this plugin
     */
    ImageEdit.prototype.dispose = function () {
        this.clearDndHelpers();
        this.disposer();
        this.disposer = null;
        this.editor = null;
    };
    /**
     * Handle events triggered from editor
     * @param event PluginEvent object
     */
    ImageEdit.prototype.onPluginEvent = function (e) {
        switch (e.eventType) {
            case 5 /* MouseDown */:
                this.setEditingImage(null);
                break;
            case 6 /* MouseUp */:
                var target = e.rawEvent.target;
                if (e.isClicking &&
                    e.rawEvent.button == 0 &&
                    roosterjs_editor_dom_1.safeInstanceOf(target, 'HTMLImageElement') &&
                    target.isContentEditable &&
                    roosterjs_editor_dom_1.matchesSelector(target, this.options.imageSelector)) {
                    this.setEditingImage(target, 7 /* ResizeAndRotate */);
                }
                break;
            case 0 /* KeyDown */:
                var key = e.rawEvent.which;
                if (key == 46 /* DELETE */ || key == 8 /* BACKSPACE */) {
                    // Set current editing image to null and select the image if any, and do not prevent default of the event
                    // so that browser will delete the selected image for us
                    this.setEditingImage(null, true /*selectImage*/);
                }
                else if (key == 27 /* ESCAPE */ && this.image) {
                    // Press ESC should cancel current editing operation, resume back to original edit info
                    this.editInfo = editInfo_1.getEditInfoFromImage(this.image);
                    this.setEditingImage(null);
                    e.rawEvent.preventDefault();
                }
                else if (key != SHIFT_KEYCODE && key != CTRL_KEYCODE && key != ALT_KEYCODE) {
                    // For other key, just unselect current image and select it. If this is an input key, the image will be replaced
                    this.setEditingImage(null, true /*selectImage*/);
                }
                break;
            case 7 /* ContentChanged */:
                if (e.source != "InsertEntity" /* InsertEntity */ ||
                    e.data.type != IMAGE_EDIT_WRAPPER_ENTITY_TYPE) {
                    // After contentChanged event, the current image wrapper may not be valid any more, remove all of them if any
                    this.editor.queryElements(roosterjs_editor_dom_1.getEntitySelector(IMAGE_EDIT_WRAPPER_ENTITY_TYPE), this.removeWrapper);
                }
                break;
            case 15 /* EntityOperation */:
                if (e.entity.type == IMAGE_EDIT_WRAPPER_ENTITY_TYPE) {
                    if (e.operation == 8 /* ReplaceTemporaryContent */) {
                        this.removeWrapper(e.entity.wrapper);
                    }
                    else if (e.operation == 1 /* Click */) {
                        e.rawEvent.preventDefault();
                    }
                }
                break;
            case 8 /* ExtractContentWithDom */:
                // When extract content, remove all image info since they may not be valid when load the content again
                roosterjs_editor_dom_1.toArray(e.clonedRoot.querySelectorAll(this.options.imageSelector)).forEach(function (img) {
                    editInfo_1.deleteEditInfo(img);
                });
                break;
        }
    };
    ImageEdit.prototype.setEditingImage = function (image, operationOrSelect) {
        var _this = this;
        var operation = typeof operationOrSelect === 'number' ? operationOrSelect : 0 /* None */;
        var selectImage = typeof operationOrSelect === 'number' ? false : !!operationOrSelect;
        if (this.image) {
            // When there is image in editing, clean up any cached objects and elements
            this.clearDndHelpers();
            // Apply the changes, and add undo snapshot if necessary
            if (applyChange_1.default(this.editor, this.image, this.editInfo, this.lastSrc, this.wasResized)) {
                this.editor.addUndoSnapshot(function () { return _this.image; }, "ImageResize" /* ImageResize */);
            }
            // Remove editing wrapper
            var wrapper = this.getImageWrapper(this.image);
            if (wrapper) {
                this.removeWrapper(wrapper);
            }
            if (selectImage) {
                this.editor.select(this.image);
            }
            this.image = null;
            this.editInfo = null;
            this.lastSrc = null;
        }
        if (!this.image && (image === null || image === void 0 ? void 0 : image.isContentEditable)) {
            // If there is new image to edit, enter editing mode for this image
            this.editor.addUndoSnapshot();
            this.image = image;
            // Get initial edit info
            this.editInfo = editInfo_1.getEditInfoFromImage(image);
            //Check if the image was resized by the user
            this.wasResized = checkIfImageWasResized(this.image);
            operation =
                (canRegenerateImage_1.default(image) ? operation : 3 /* Resize */) &
                    this.allowedOperations;
            // Create and update editing wrapper and elements
            var wrapper = this.createWrapper(operation);
            this.updateWrapper();
            // Init drag and drop
            this.dndHelpers = __spreadArrays(this.createDndHelpers("r_resizeH" /* ResizeHandle */, Resizer_1.Resizer), this.createDndHelpers("r_rotateH" /* RotateHandle */, Rotator_1.Rotator), this.createDndHelpers("r_cropH" /* CropHandle */, Cropper_1.Cropper), this.createDndHelpers("r_cropC" /* CropContainer */, Cropper_1.Cropper));
            // Put cursor next to the image
            this.editor.select(wrapper, -3 /* After */);
        }
    };
    /**
     * Create editing wrapper for the image
     */
    ImageEdit.prototype.createWrapper = function (operation) {
        var _this = this;
        // Wrap the image with an entity so that we can easily retrieve it later
        var wrapper = roosterjs_editor_api_1.insertEntity(this.editor, IMAGE_EDIT_WRAPPER_ENTITY_TYPE, roosterjs_editor_dom_1.wrap(this.image, 6 /* ImageEditWrapper */), false /*isBlock*/, true /*isReadonly*/).wrapper;
        wrapper.style.position = 'relative';
        wrapper.style.maxWidth = '100%';
        wrapper.style.verticalAlign = 'bottom';
        wrapper.style.display = roosterjs_editor_dom_1.Browser.isSafari ? 'inline-block' : 'inline-flex';
        // Cache current src so that we can compare it after edit see if src is changed
        this.lastSrc = this.image.src;
        // Set image src to original src to help show editing UI, also it will be used when regenerate image dataURL after editing
        this.image.src = this.editInfo.src;
        this.image.style.position = 'absolute';
        this.image.style.maxWidth = null;
        // Get HTML for all edit elements (resize handle, rotate handle, crop handle and overlay, ...) and create HTML element
        var options = {
            borderColor: this.options.borderColor,
            rotateIconHTML: this.options.rotateIconHTML,
            rotateHandleBackColor: this.editor.isDarkMode()
                ? DARK_MODE_BGCOLOR
                : LIGHT_MODE_BGCOLOR,
        };
        var htmlData = [];
        Object.keys(ImageEditHTMLMap).forEach(function (thisOperation) {
            if ((operation & thisOperation) == thisOperation) {
                roosterjs_editor_dom_1.arrayPush(htmlData, ImageEditHTMLMap[thisOperation](options));
            }
        });
        htmlData.forEach(function (data) {
            var element = roosterjs_editor_dom_1.createElement(data, _this.image.ownerDocument);
            if (element) {
                wrapper.appendChild(element);
            }
        });
        return wrapper;
    };
    /**
     * Get image wrapper from image
     * @param image The image to get wrapper from
     */
    ImageEdit.prototype.getImageWrapper = function (image) {
        var _a;
        // Get the image wrapper from image using Entity API
        var entity = roosterjs_editor_dom_1.getEntityFromElement((_a = image === null || image === void 0 ? void 0 : image.parentNode) === null || _a === void 0 ? void 0 : _a.parentNode);
        return (entity === null || entity === void 0 ? void 0 : entity.type) == IMAGE_EDIT_WRAPPER_ENTITY_TYPE ? entity.wrapper : null;
    };
    /**
     * Create drag and drop helpers
     * @param wrapper
     * @param elementClass
     * @param dragAndDrop
     */
    ImageEdit.prototype.createDndHelpers = function (elementClass, dragAndDrop) {
        var _this = this;
        var commonContext = {
            editInfo: this.editInfo,
            options: this.options,
            elementClass: elementClass,
        };
        var wrapper = this.getImageWrapper(this.image);
        return wrapper
            ? getEditElements(wrapper, elementClass).map(function (element) {
                return new DragAndDropHelper_1.default(element, __assign(__assign({}, commonContext), { x: element.dataset.x, y: element.dataset.y }), _this.updateWrapper, dragAndDrop);
            })
            : [];
    };
    /**
     * Clean up drag and drop helpers
     */
    ImageEdit.prototype.clearDndHelpers = function () {
        var _a;
        (_a = this.dndHelpers) === null || _a === void 0 ? void 0 : _a.forEach(function (helper) { return helper.dispose(); });
        this.dndHelpers = null;
    };
    return ImageEdit;
}());
exports.default = ImageEdit;
function setSize(element, left, top, right, bottom, width, height) {
    element.style.left = getPx(left);
    element.style.top = getPx(top);
    element.style.right = getPx(right);
    element.style.bottom = getPx(bottom);
    element.style.width = getPx(width);
    element.style.height = getPx(height);
}
function getPx(value) {
    return value === undefined ? null : value + 'px';
}
function getEditElements(wrapper, elementClass) {
    return roosterjs_editor_dom_1.toArray(wrapper.querySelectorAll('.' + elementClass));
}
function isRtl(element) {
    return roosterjs_editor_dom_1.safeInstanceOf(element, 'HTMLElement')
        ? roosterjs_editor_dom_1.getComputedStyle(element, 'direction') == 'rtl'
        : false;
}
function handleRadIndexCalculator(angleRad) {
    var idx = Math.round(angleRad / DirectionRad) % DIRECTIONS;
    return idx < 0 ? idx + DIRECTIONS : idx;
}
function rotateHandles(element, angleRad) {
    var radIndex = handleRadIndexCalculator(angleRad);
    var originalDirection = element.dataset.y + element.dataset.x;
    var originalIndex = DirectionOrder.indexOf(originalDirection);
    var rotatedIndex = originalIndex >= 0 && originalIndex + radIndex;
    return DirectionOrder[rotatedIndex % DIRECTIONS];
}
/**
 * Rotate the resizer and cropper handles according to the image position.
 * @param handles The resizer handles.
 * @param angleRad The angle that the image was rotated.
 */
function updateHandleCursor(handles, angleRad) {
    handles.map(function (handle) {
        handle.style.cursor = rotateHandles(handle, angleRad) + "-resize";
    });
}
/**
 * Check if the current image was resized by the user
 * @param image the current image
 * @returns if the user resized the image, returns true, otherwise, returns false
 */
function checkIfImageWasResized(image) {
    var width = image.width, height = image.height, style = image.style;
    var isMaxWidthInitial = style.maxWidth === '' || style.maxWidth === 'initial' || style.maxWidth === 'auto';
    if (isMaxWidthInitial &&
        (isFixedNumberValue(style.height) ||
            isFixedNumberValue(style.width) ||
            isFixedNumberValue(width) ||
            isFixedNumberValue(height))) {
        return true;
    }
    else {
        return false;
    }
}
function isFixedNumberValue(value) {
    var numberValue = typeof value === 'string' ? parseInt(value) : value;
    return !isNaN(numberValue);
}
//# sourceMappingURL=ImageEdit.js.map